import React from 'react';


export default function FieldTimeReportViewInImport(props) {

    return (
        <div className="ui5-txt-default-small">
            {gd.utils.formatTimeSpent(props.value)}
        </div>
    );
}